// User Roles
export const USER_ROLES = {
  VISITOR: "visitor",
  PERFORMER: "performer",
  HOST: "host",
  ADMIN: "admin",
};

// Role Permissions
export const ROLE_PERMISSIONS = {
  [USER_ROLES.VISITOR]: {
    canViewProfiles: true,
    canFilter: true,
    canInitiateCalls: false,
    canBuyCredits: false,
    canUploadContent: false,
    canBoostVisibility: false,
  },
  [USER_ROLES.PERFORMER]: {
    canViewProfiles: true,
    canFilter: true,
    canInitiateCalls: true,
    canBuyCredits: true,
    canUploadContent: true,
    canBoostVisibility: true,
    canSetAvailability: true,
    canEarnCredits: true,
  },
  [USER_ROLES.HOST]: {
    canViewProfiles: true,
    canFilter: true,
    canInitiateCalls: true,
    canBuyCredits: true,
    canUploadContent: true,
    canBoostVisibility: true,
    canPublishVenue: true,
    canEarnCredits: true,
  },
  [USER_ROLES.ADMIN]: {
    canViewProfiles: true,
    canFilter: true,
    canInitiateCalls: true,
    canBuyCredits: true,
    canUploadContent: true,
    canBoostVisibility: true,
    canModerateContent: true,
    canApproveUsers: true,
    canManageCredits: true,
    canManageSettings: true,
  },
};

// Credit costs
export const CREDIT_COSTS = {
  CALL_PER_MINUTE: 1,
  DISCOVER_TOP_BOOST: 5, // 24h
  STORY_VISIBILITY: 2, // 24h
  MONTHLY_PREMIUM: 30, // 30 days
  MAP_VISIBILITY: 0, // Free
};

// Credit redemption (future feature)
export const CREDIT_REDEMPTION_RATE = 0.5; // 1 credit = 0.5 EUR/USD

// Default role for new users
export const DEFAULT_ROLE = USER_ROLES.PERFORMER;

// Role display names
export const ROLE_DISPLAY_NAMES = {
  [USER_ROLES.VISITOR]: "Visitor",
  [USER_ROLES.PERFORMER]: "Performer",
  [USER_ROLES.HOST]: "Host",
  [USER_ROLES.ADMIN]: "Admin",
};

